/**
 * 编码 Spark ID 为混淆的字符串
 * 使用 base64 编码，并添加一些混淆字符
 */
export function encodeSparkId(id: number): string {
  // 添加一个固定的偏移量来混淆
  const offset = 12345;
  const encoded = id + offset;
  // 转换为 base64
  let base64 = btoa(String(encoded));
  // 替换为 URL 安全的字符
  base64 = base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  // 添加前缀确保不是纯数字
  return `sp_${base64}`;
}

/**
 * 解码混淆的字符串为 Spark ID
 */
export function decodeSparkId(encoded: string): number | null {
  try {
    // 检查是否有正确的前缀
    if (!encoded.startsWith("sp_")) {
      return null;
    }
    // 移除前缀
    const base64Str = encoded.slice(3);
    // 恢复 base64 字符串（替换 URL 安全的字符）
    let base64 = base64Str.replace(/-/g, "+").replace(/_/g, "/");
    // base64 字符串长度必须是 4 的倍数，添加必要的填充
    while (base64.length % 4 !== 0) {
      base64 += "=";
    }
    
    const decoded = atob(base64);
    const id = Number.parseInt(decoded, 10);
    const offset = 12345;
    
    if (Number.isNaN(id)) {
      return null;
    }
    
    return id - offset;
  } catch {
    return null;
  }
}

